import React, { useState, useCallback } from 'react'
import { Box } from '@mui/material'
import { useAuth } from '../../context/AuthContext'
import { useLocation } from 'react-router-dom'
import TopAppBar from './TopAppBar'
import SidebarDrawer from './SidebarDrawer'
import RoutesConfig from '../routes/RoutesConfig'
import useSocketNotifications from '../hooks/useSocketNotifications'
import Notifications from '../notifications/Notifications'

const DRAWER_WIDTH = 240
const APP_BAR_HEIGHT = 65
const PUBLIC_ROUTES = ['/login', '/register', '/forgot-password']

const AppLayout = () => {
  const { user } = useAuth()
  const location = useLocation()

  const [drawerOpen, setDrawerOpen] = useState(false)
  const [notifOpen, setNotifOpen] = useState(false)
  const [unReadNotifications, setUnReadNotifications] = useState(0)

  const { unReadEmail } = useSocketNotifications(user || null)

  const handleDrawerToggle = useCallback(() => {
    setDrawerOpen((prev) => !prev)
  }, [])

  const handleNotifToggle = useCallback(() => {
    setNotifOpen((prev) => !prev)
  }, [])

  const handleUnread = (count) => {
    setUnReadNotifications(count)
  }

  const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname)
  if (!user || isPublicRoute) {
    return (
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          width: '100%',
          height: '100%'
        }}
      >
        <RoutesConfig />
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', flex: 1, maxWidth: '100%' }}>
      <TopAppBar
        open={drawerOpen}
        handleDrawerToggle={handleDrawerToggle}
        handleOpenNotif={handleNotifToggle}
        unReadNotifications={unReadNotifications}
        unReadEmail={unReadEmail}
      />
      <SidebarDrawer open={drawerOpen} drawerWidth={DRAWER_WIDTH} />
      <Notifications open={notifOpen} sendUnread={handleUnread} closeFunction={handleNotifToggle} />

      <Box
        component='main'
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width: { sm: `calc(100% - ${DRAWER_WIDTH}px)` },
          height: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
          marginTop: `${APP_BAR_HEIGHT}px`,
          overflow: 'hidden',
          minHeight: 0
        }}
      >
        <RoutesConfig />
      </Box>
    </Box>
  )
}

export default AppLayout
